import React from 'react'
import JotformEmbed from 'react-jotform-embed';
import { Container, Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import './../App.css'

const useStyles = makeStyles(theme => ({
    pagetitle:{
     color: '#231f20',
     fontFamily:'Poppins',
     paddingTop:'30px',
     fontSize: '42px'
    }
}));

function Contactform() {
    const classes = useStyles();

    return (
        <div>
            <Container maxWidth="sm" component="main" className={classes.heroContent}>
        <Typography align="center"className={classes.pagetitle} >
          CONTACT FORM
        </Typography>       
      </Container>
      <Grid container>
             <JotformEmbed src="https://form.jotform.com/200904356389965" />
          </Grid>            
      <div style={{marginBottom: '50px'}}></div>   
       </div>
    )
}
export default Contactform